<script setup>
import { ref, onMounted, onUnmounted, defineProps } from 'vue';
import { Popover } from 'bootstrap';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  placement: {
    type: String,
    default: 'bottom'
  }
});

const triggerRef = ref(null);
const contentRef = ref(null);
let popover = null;

const handleOutsideClick = (event) => {
  if (triggerRef.value && 
      !triggerRef.value.contains(event.target) && 
      !event.target.closest('.popover')) {
    popover?.hide();
  }
};

onMounted(() => {
  if (triggerRef.value && contentRef.value) {
    popover = new Popover(triggerRef.value, {
      container: 'body',
      placement: props.placement,
      trigger: 'click',
      html: true,
      content: contentRef.value.innerHTML
    });

    document.addEventListener('click', handleOutsideClick);
  }
});

onUnmounted(() => {
  if (popover) {
    popover.dispose();
  }
  document.removeEventListener('click', handleOutsideClick);
});
</script>

<template>
  <div class="d-inline-block">
    <div ref="triggerRef">
      <slot name="trigger"></slot>
    </div>
    <div ref="contentRef" style="display: none;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicPopover'
}
</script>